<ng-container *ngIf="show">
  <app-modal [attr.link]="getShortText()" title="Info">
    <div class="text-left" [innerHTML]="text"></div>
  </app-modal>
</ng-container>
<span *ngIf="!show" [innerHTML]="text"></span>
